import Swal from "sweetalert2";
import { DefaultService } from "../services/default/default.service";
import { Reservation } from "../models/reservation-model";
import { Router } from "@angular/router";
import { ProfileService } from "../services/profile/profile.service";
import { CustomService } from "../services/custom/custom.service";
import { FormGroup } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "src/environments/environment";
import { GenerateErrors } from "./generate-errors";
import { Webflow } from "./webflow";

export class CustomActions {
  constructor(
    public defaultService: DefaultService,
    public router: Router,
    private spinner: NgxSpinnerService,
    public customService: CustomService
  ) {}

  section_html_edit_page(endpoint: string, data: any) {
    var result = "";
    return result;
  }

  generate_edit_buttons(endpoint: string, data: any) {
    var studio_buttons = [];

    if (endpoint == "studios") {
      /*
      studio_buttons.push({
        title: "Horaires d'ouverture",
        action: () => {
          this.router.navigate(["/studios/" + data.id + "/opening-slots"], {});
        },
        icon: "ni ni-calendar-grid-58",
        type: "primary",
      });
      */

      studio_buttons.push({
        title: "Périodes de réduction",
        action: () => {
          var content_html = `
          <div style="margin-left:20px;margin-right:20px;">
             <h2>Périodes de réduction</h2>
             <p>Veuillez compléter le formulaire pour l'envoyer à l'équipe administrative de StudioMap</p>
             <label style="margin-top:20px;">Jour :</label>
             <select class="form-control text-center" id="day-selected">
                <option value="Lundi">Lundi</option>
                <option value="Mardi">Mardi</option>
                <option value="Mercredi">Mercredi</option>
                <option value="Jeudi">Jeudi</option>
                <option value="Vendredi">Vendredi</option>
                <option value="Samedi">Samedi</option>
                <option value="Dimanche">Dimanche</option>
             </select>
             <label style="margin-top:10px;">Heure de début (ex : 09:00:00) :</label>
             <input style="font-weight:bold;color: #007daa;" type="text" value="" class="form-control text-center" id="start-time" />
             <label style="margin-top:10px;">Heure de fin (ex : 11:00:00) :</label>
             <input style="font-weight:bold;color: #007daa;" type="text" value="" class="form-control text-center" id="end-time" />
             <label style="margin-top:10px;">Valeur de la réduction (%) :</label>
             <input style="font-weight:bold;color: #007daa;" type="number" min="0" max="100" value="0" class="form-control text-center" id="discount-rate" />
             <textarea style="font-weight:bold;color: #007daa;margin-top:10px" row="5" class="form-control text-center" placeholder="Votre message..." id="description"></textarea>
          </div>
        `;

          Swal.fire({
            title: "",
            html: content_html,
            icon: "info",
            showCancelButton: true,
            cancelButtonText: "Fermer",
            confirmButtonText: "Envoyer",
            focusConfirm: false,
            cancelButtonColor: "black",
            confirmButtonColor: "red",
            preConfirm: () => {
              const day_selected_html = document.getElementById(
                "day-selected"
              ) as HTMLInputElement | null;
              let day_selected =
                day_selected_html != null ? day_selected_html.value : "";

              const start_time_html = document.getElementById(
                "start-time"
              ) as HTMLInputElement | null;
              let start_time =
                start_time_html != null ? start_time_html.value : "";

              const end_time_html = document.getElementById(
                "end-time"
              ) as HTMLInputElement | null;
              let end_time = end_time_html != null ? end_time_html.value : "";

              const discount_rate_html = document.getElementById(
                "discount-rate"
              ) as HTMLInputElement | null;
              let discount_rate =
                discount_rate_html != null ? discount_rate_html.value : "";

              const description_html = document.getElementById(
                "description"
              ) as HTMLInputElement | null;
              let description =
                description_html != null ? description_html.value : "";

              return [
                day_selected,
                start_time,
                end_time,
                discount_rate,
                description,
              ];
            },
          }).then((result) => {
            if (result.isConfirmed) {
              const selectedOptions = result.value;
              if (selectedOptions && selectedOptions.length > 0) {
                let day_selected = selectedOptions[0];
                let start_time = selectedOptions[1];
                let end_time = selectedOptions[2];
                let discount_rate = selectedOptions[3];
                let description = selectedOptions[4];
                this.defaultService
                  .post("studios/modify-discount-periods", {
                    discount_period: {
                      day_selected: day_selected,
                      start_time: start_time,
                      end_time: end_time,
                      discount_rate: discount_rate,
                      description: description,
                    },
                    studio: {
                      id: data.id,
                      name: data.name,
                      private_name: data.private_name,
                    },
                  })
                  .subscribe(
                    (res) => {
                      Swal.fire({
                        title: "Félicitation",
                        text: "La demande a été envoyée avec succès",
                        icon: "success",
                        position: "top",
                      });
                    },
                    (err) => {
                      if (
                        err.error.error.details != undefined &&
                        err.error.error.details.message != undefined
                      ) {
                        Swal.fire({
                          title: "Attention",
                          text: err.error.error.details.message,
                          icon: "info",
                          position: "top",
                        });
                      } else {
                        Swal.fire({
                          title: "Erreur",
                          text: "Une érreur est survenue",
                          icon: "error",
                          position: "top",
                        });
                      }
                    }
                  );
              }
            }
          });
        },
        icon: "ni ni-tag",
        type: "warning",
      });
    }

    return {
      studios: studio_buttons,
    };
  }

  static generate_autocomplate_filters(endpoint: string, value: string) {
    let filters = "";

    if (endpoint == "profiles") {
      filters = "&filters[email][$contains]=" + value;
    }

    if (endpoint == "studios") {
      filters = "&filters[name][$contains]=" + value;
    }

    return filters;
  }

  static check_not_null(endpoint: string, data: any): boolean {
    var is_null: boolean = false;

    if (endpoint == "studios") {
      is_null = data.manager != null;
    }
    return is_null;
  }

  async custom_add_submit(
    endpoint: string,
    form: FormGroup,
    inputs: Array<any>,
    spinner: NgxSpinnerService
  ): Promise<boolean> {
    let value = false;
    return value;
  }

  generate_custom_buttons_for_table(endpoint: string, data: any) {
    let reservation_buttons = [];

    if (endpoint == "reservations") {
      if (
        data["status"] == "waiting-confirmation" ||
        data["status"] == "confirmed"
      ) {
        if (data["show_button_accpet"]) {
          reservation_buttons.push({
            title: "Accepter la réservation",
            icon: "fa fa-check",
            class: "text-success",
            onClick: () => {
              Webflow.setIFrameHeight();
              Swal.fire({
                title: "Accepter la réservation",
                text: "Étes-vous sûre de vouloir acceptée la réservation ?",
                icon: "info",
                showCancelButton: true,
                confirmButtonText: `Confirmer`,
                cancelButtonText: `Annuler`,
                cancelButtonColor: "black",
                confirmButtonColor: "#D63333",
                position: "top",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.defaultService
                    .post("reservations/" + data["id"] + "/manager/accept", {})
                    .subscribe(
                      (res) => {
                        Swal.fire({
                          title: "Félicitation",
                          text: "La réservation a été acceptée avec succès",
                          icon: "success",
                          position: "top",
                        });
                        window.location.reload();
                      },
                      (err) => {
                        if (
                          err.error.error.details != undefined &&
                          err.error.error.details.message != undefined
                        ) {
                          Swal.fire({
                            title: "Attention",
                            text: err.error.error.details.message,
                            icon: "info",
                            position: "top",
                          });
                        } else {
                          Swal.fire({
                            title: "Erreur",
                            text: "Une érreur est survenue",
                            icon: "error",
                            position: "top",
                          });
                        }
                      }
                    );
                }
              });
            },
          });
        }

        if (data["show_button_cancel"]) {
          reservation_buttons.push({
            title: "Annuler la réservation",
            icon: "ni ni-fat-remove fa-lg",
            class: "text-danger",
            onClick: () => {
              var content_html = `
              <div style="margin-left:20px;margin-right:20px;margin-top:10px;">
                   <p>Étes-vous sûre de vouloir annulée la réservation ?</p>
              </div>
              `;

              Webflow.setIFrameHeight();
              Swal.fire({
                title: "Annuler la réservation",
                html: content_html,
                icon: "info",
                showCancelButton: true,
                confirmButtonText: `Confirmer`,
                cancelButtonText: `Annuler`,
                cancelButtonColor: "black",
                confirmButtonColor: "#D63333",
                position: "top",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.defaultService
                    .post("reservations/" + data["id"] + "/manager/cancel", {})
                    .subscribe(
                      (res) => {
                        window.location.reload();

                        Swal.fire({
                          title: "Félicitation",
                          text: "La réservation a été annulée avec succès",
                          icon: "success",
                          position: "top",
                        });
                      },
                      (err) => {
                        if (
                          err.error.error.details != undefined &&
                          err.error.error.details.message != undefined
                        ) {
                          Swal.fire({
                            title: "Attention",
                            text: err.error.error.details.message,
                            icon: "info",
                            position: "top",
                          });
                        } else {
                          Swal.fire({
                            title: "Erreur",
                            text: "Une érreur est survenue",
                            icon: "error",
                            position: "top",
                          });
                        }
                      }
                    );
                }
              });
            },
          });
        }
      }
    }
    return {
      reservations: reservation_buttons,
    }[endpoint];
  }
}
